var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkeepersIconShort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262 262.6",
    style: {
      enableBackground: "new 0 0 262 262.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0073FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 215.1,
    cy: 48.1,
    r: 41.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 47.8,
    cy: 215.4,
    r: 41.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.3,6.3H89.6C43.4,6.3,6,43.7,6,89.9s37.4,83.6,83.6,83.6V89.9h83.6V6.3H173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.3,89.9v83.6H89.6v83.6h83.6l0,0c46.2,0,83.6-37.4,83.6-83.6C256.9,127.4,219.4,89.9,173.3,89.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeepersIconShort);
export default __webpack_public_path__ + "static/media/skeepersIconShort.c577466a76fab924cb9b336081fd2f54.svg";
export { ForwardRef as ReactComponent };